import {TranslatedKeys} from 'shared/types/translated-keys';

export enum PaymentTypeEnum {
  ONLINE = 'ONLINE',
  IN_PERSON = 'IN_PERSON',
}

export interface PaymentMethodProps {
  id: string;
  name: string;
  type: PaymentTypeEnum;
  active: boolean;
  change?: number;
  pixChange?: string;
}

export const translatedPaymentMethodProps: TranslatedKeys<PaymentMethodProps> =
  {
    name: 'Nome',
    type: 'Tipo do pagamento',
    active: 'Ativo?',
    change: 'Troco',
    pixChange: 'Pix para o troco',
  };
